<template>
  <div class="filter-bar" @click="select">
    <span>
      {{ month }}月
      <i class="caret"></i>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    var month = new Date().getMonth() + 1

    return {
      month
    };
  },
  methods: {
    select() {
      var me = this,
        month = me.month,
        months = []
      for (let i = 1; i <= 12; i++) {
        months.push({
          value: i,
          label: i + "月"
        });
      }
      me.$weui.picker(
        months,
        {
          title: "选择月份",
          defaultValue: [month],
          onConfirm: function (r) {
            me.month = r[0].value
            me.$emit("change", me.month);
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
</style>